<template>

<div class="articles-admin-detail" v-if="loading.length == 0">
	<div>
		<label>Title</label>
		<input type="text" v-model="kbItem.topic">
		<div class="two-columns">
			<div class="form-quarter">
				<label>Category</label>
				<select v-model="kbItem.kb_category_id">
					<option value="">Select Category...</option>
					<option v-for="(kbCategory, index) in kbCategories" :value="kbCategory.kb_category_id">{{ kbCategory.description }}</option>
				</select>
			</div>
            <div class="form-quarter">
				<label>Parent Article</label>
				<select v-model="kbItem.parent_item_id" v-if="kbItem.kb_category_id">
					<option value="">Select Parent Article...</option>
					<option v-for="(parentArticle, index) in kbItems" :value="parentArticle.kb_item_id">{{ parentArticle.topic }}</option>
				</select>
                <select v-else disabled>
                    <option value="">Please select a category first...</option>
                </select>
                <a class="sorting-link" @click="showSortingModal" v-if="kbItem.kb_category_id && !contentChanged">Sort</a>
                <a class="sorting-link disabled" href="#" v-else>Sort</a>
                <div class="modal sorting-modal" v-if="sortingModalShowing">
                    <div class="inner">
                        <template v-if="!sortingModalLoading">
                            <ul>
                                <draggable class="sections" v-model="kbSortableItems" v-bind="sortableItemsOptions" @change="endDrag">
                                    <li class="draggable" v-for="(item, index) in kbSortableItems">{{ item.topic }} <i class="fas fa-grip-horizontal drag"></i></li>
                                </draggable>
                            </ul>
                            <div class="controls">
                    			<div class="button cancel" @click="sortingModalShowing = false">Done</div>
                    		</div>
                        </template>
                        <loading v-else></loading>
                    </div>
                </div>
			</div>
			<div class="form-quarter control-group">
				<label class="radio first">
					<input type="radio" v-model="kbItem.internal_use_only" value="0">
					<span class="published"><i class="fas fa-check-circle"></i>Published</span>
				</label>
				<label class="radio last">
					<input type="radio" v-model="kbItem.internal_use_only" value="1">
					<span class="unpublished"><i class="fas fa-check-circle"></i>Unpublished</span>
				</label>
                <label class="checkbox" style="margin-left: 2em;">
					<input type="checkbox" v-model="kbItem.common" value="1">
					<span class="common"><i class="fas fa-check-circle"></i>Common</span>
				</label>
			</div>
		</div>

	</div>

	<div>
		<ckeditor :editor="editor" v-model="kbItem.content" :config="editorConfig"></ckeditor>
	</div>

    <div class="two-columns">
        <div class="tags form-quarter">
            <label>Article Tags</label>
            <input type="text" v-model="tagFilter" @keyup.down="moveSelectedTag" @keyup.up="moveSelectedTag" @keyup.enter.prevent="addTag">
            <ul class="filtered-tags" v-if="filteredTags.length > 0">
                <li :class="{ selected: index == selectedTagIndex }" v-for="(tag, index) in filteredTags" :key="'filtered-tag-' + index" @mouseover="selectedTagIndex = index" @click="addTag">{{ tag.description }}</li>
            </ul>
            <ul class="tag-list">
                <li v-for="(tag, index) in kbItem.kb_tags" v-if="!tag.delete">
                    {{ tag.description }}
                    <i class="fa fa-times" @click="removeTag(index)"></i>
                </li>
            </ul>
        </div>
        <div class="form-quarter">
            <label>Video Link</label>
            <input type="text" v-model="kbItem.video_link">
        </div>
    </div>
    <div class="form-quarter ">
        <label for="">Related Articles</label>
        <div class="input-with-control">
            <input type="search" placeholder="Search..." v-model="kbRelatedItemsSearchTerm" @keyup.enter="kbRelatedItemsSearch" @keyup.esc="kbRelatedItemsSearchItems = []">
            <div class="button action input-go" @click="kbRelatedItemsSearch"><i class="fas fa-search"></i></div>
        </div>
    </div>
    <div class="two-columns related-articles">
        <!-- <h3>Related Articles</h3> -->
        <table class="kb-items-available">
            <tr v-for="(available, index) in kbRelatedItemsAvailable">
                <td>{{ available.topic }}</td>
                <td><button class="primary" @click="addRelatedKbItem(index)"><i class="fas fa-chevron-right"></i></button></td>
            </tr>
        </table>
        <table class="kb-items-selected">
            <tr v-for="(kbRelatedItem, index) in kbItem.kb_related_items" v-if="!kbRelatedItem.delete">
                <td><button class="delete" @click="removeRelatedKbItem(index)"><i class="fas fa-times link pointer"></i></button></td>
                <td>{{ kbRelatedItem.topic }}</td>
            </tr>
        </table>
    </div>

	<div class="controls detail-controls">
        <button class="button primary spaced" @click="saveArticle" v-if="!saving"><span><i class="fas fa-check"></i> Save</span></button>
        <button class="button primary saving spaced" v-else><span><i class="fas fa-check"></i> Saving...</span></button>
		<router-link tag="button" to="/admin/articles" class="button close spaced" v-if="!contentChanged"><span><i class="fas fa-chevron-left"></i> Back to List</span></router-link>
		<button class="button alert spaced" @click="cancel = true" v-else-if="!cancel">Cancel</button>
		<router-link tag="button" to="/admin/articles" class="button alert spaced" @click="cancel = true" v-else>Confirm</router-link>
	</div>

</div>

<loading class="full-page" v-else></loading>

</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import { Undo, Redo } from '@ckeditor/ckeditor5-undo/src/';

import CDSUploadAdapter from '@/modules/dashboard/components/dashboarduploadadapter.js';

import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'help-center-articles-detail',
    props: [ 'category_link_name', 'kb_item_id' ],
    components: {
        'ckeditor': CKEditor.component
    },
    data() {
        return {
            loading: [],
            sortingModalLoading: false,
            saving: false,
            editor: ClassicEditor,
			editorConfig: {
                plugins: [
					Alignment,
					Image,
					ImageToolbar,
					ImageCaption,
					ImageStyle,
					ImageResize,
					ImageUpload,
                    Bold,
                    Italic,
					Underline,
                    Link,
                    Paragraph,
					Heading,
					List,
                    Undo
                ],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
						'underline',
						'heading',
						'link',
						'numberedList',
						'bulletedList',
                        'undo',
                        'redo',
                        'imageUpload'
                    ]
                },
				extraPlugins: [ this.theUploadAdapterPlugin ],
				heading: {
		            options: [
		                { model: 'paragraph', title: 'Paragraph' },

						{ model: 'heading2', view: 'h2', title: 'Heading 1' },
                        { model: 'heading3', view: 'h3', title: 'Heading 2' },
		                {
                            model: 'note',
                            view: {
                                name: 'div',
                                classes: 'note'
                            },
                            title: 'Note',
                        },
					]
				},
				image: {
		            // You need to configure the image toolbar, too, so it uses the new style buttons.
		            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],

		            styles: [
		                // This option is equal to a situation where no style is applied.
		                'full',

		                // This represents an image aligned to the left.
		                'alignLeft',

		                // This represents an image aligned to the right.
		                'alignRight'
		            ]
		        },
    			link: {
					decorators: {
						openInNewTab: {
							mode: 'manual',
							label: 'Open in new tab',
							attributes: {
							    target: '_blank',
							    rel: 'noopener noreferrer' // prevent reverse tabnabbing
							}
						}
					}
				}
            },
            kbItem: {
                description: '',
                kb_category_id: '',
                parent_item_id: '',
                internal_use_only: 1,
                content: '',
                kb_tags: [],
                kb_related_items: [],
                video_link: '',
                sort_order: 0
            },
            kbItemCopy: {
                description: '',
                kb_category_id: '',
                parent_item_id: '',
                internal_use_only: 1,
                content: '',
                kb_tags: [],
                kb_related_items: [],
                video_link: '',
                sort_order: 0
            },
            kbItems: [],
            kbCategories: [],
            kbTags: [],
            parentArticleList: [],
            sortingModalShowing: false,
            cancel: false,
            tagFilter: null,
            newTag: '',
            "arrow-keys": [ 38, 40 ],
            selectedTagIndex: 0,
            kbRelatedItemsSearchTerm: null,
            kbRelatedItemsAvailable: [],
            kbSortableItems: []
        }
    },
    created() {
        if (this.kb_item_id != 'new') {
            this.fetchData()
        }
        this.fetchListKBItemsFlat()
        this.fetchListKBTags()
        this.fetchListKBCategories()
    },
    watch: {
        kb_item_id(newVal, oldVal) {
            if (newVal != 'new' && (newVal != oldVal)) {
                this.fetchData()
                this.fetchListKBTags()
                this.fetchListKBCategories()
                this.fetchListKBItemsFlat()
            } else if (newVal == 'new') {
                this.fetchListKBTags()
                this.fetchListKBCategories()
                this.fetchListKBItemsFlat()
                this.kbItem = {
                    description: '',
                    kb_category_id: '',
                    parent_item_id: '',
                    internal_use_only: 1,
                    content: '',
                    kb_tags: [],
                    kb_related_items: [],
                    video_link: '',
                    sort_order: 0
                }
                this.kbItemCopy = this.$copy(this.kbItem)
            }
        },
        'kbItem.kb_category_id'(newVal, oldVal) {
            if (newVal != oldVal) {
                this.fetchListKBItemsFlat()
            }
        },
        kbRelatedItemsSearchTerm(newVal, oldVal) {
            if (!newVal) {
                this.kbRelatedItemsAvailable = []
            }
        }
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getKBItem'
        ]),
        contentChanged() {
			if (this.kbItem.internal_use_only != this.kbItemCopy.internal_use_only) return true
			if (this.$changed(this.kbItem, this.kbItemCopy)) return true
			return false
		},
        filteredTags() {
            if (!this.tagFilter) {
                return []
            }
            var filteredTags = this.kbTags.filter(filteredTag => {
                return filteredTag.description.indexOf(this.tagFilter) > -1 && this.tagNotInTagsList(filteredTag.description)
            })
            return filteredTags
        },
        sortableItemsOptions() {
			return {
				group: { name: 'sortable_items' },
				draggable: '.draggable',
				ghostClass: "sortable-ghost",
				chosenClass: "sortable-chosen",
				dragClass: "sortable-drag",
				handle: ".drag"
			}
		}
    },
    methods: {
        ...mapActions('dashboard_module', [
            'updateKBItem'
        ]),
        fetchData() {
            this.loading.push('get_item_kb_item')
            var data = {
                kb_item_id: this.kb_item_id
            }
            this.apiCall({ destination: 'get_item_kb_item', data: data }).then(obj => {
                this.loading.splice(this.loading.indexOf('get_item_kb_item'), 1)
                this.updateKBItem(obj.kb_item)
                this.kbItem = obj.kb_item
                this.kbItemCopy = this.$copy(obj.kb_item)
            }).catch(err => {
                console.log(err);
            })
        },
        fetchListKBTags() {
            this.loading.push('get_list_kb_tags')
            this.apiCall({ destination: 'get_list_kb_tags' }).then(obj => {
                this.loading.splice(this.loading.indexOf('get_list_kb_tags'), 1)
                this.kbTags = obj.kb_tags
            }).catch(err => {
                console.log(err);
            })
        },
        fetchListKBCategories() {
            this.loading.push('get_list_kb_categories')
            this.apiCall({ destination: 'get_list_kb_categories' }).then(obj => {
                this.loading.splice(this.loading.indexOf('get_list_kb_categories'), 1)
                this.kbCategories = obj.kb_categories
            }).catch(err => {
                console.log(err);
            })
        },
        fetchListKBItemsFlat() {
            this.loading.push('get_list_kb_items_flat')
            this.apiCall({ destination: 'get_list_kb_items', data: { kb_category_id: this.kbItem.kb_category_id, kb_item_id: this.kb_item_id } }).then(obj => {
                this.loading.splice(this.loading.indexOf('get_list_kb_items_flat'), 1)
                this.kbItems = obj.kb_items
            }).catch(err => {
                console.log(err);
            })
        },
        showSortingModal() {
            this.sortingModalShowing = true
            this.sortingModalLoading = true
            this.apiCall({ destination: 'get_list_kb_items', data: { parent_item_id: (this.kbItem.parent_item_id) ? this.kbItem.parent_item_id : 'root' } }).then(obj => {
                this.sortingModalLoading = false
                this.kbSortableItems = obj.kb_items
            }).catch(err => {
                this.sortingModalLoading = false
                console.log(err);
            })
        },
        endDrag(evt) {
            this.sortingModalLoading = true
            this.apiCall({ destination: 'save_kb_items_sort_order', data: { kb_items: this.kbSortableItems } }).then(obj => {
                this.sortingModalLoading = false
                this.fetchKBMenu()
                this.fetchData()
            }).catch(err => {
                this.sortingModalLoading = false
                console.log(err);
            })
        },
        fetchKBMenu() {
            this.apiCall({ destination: 'get_kb_menu' }).then(obj => {
                // this.kbItems = obj.kb_items
            }).catch(err => {
                console.log(err);
            })
        },
        kbRelatedItemsSearch() {
            if (!this.kbRelatedItemsSearchTerm) return
            var data = {
                kb_item_id: this.kb_item_id,
                search_term: this.kbRelatedItemsSearchTerm
            }
            if (this.kbItem.kb_related_items.length > 0) {
                data.related_item_ids = this.kbItem.kb_related_items.map(item => item.related_item_id)
            }
            this.apiCall({ destination: 'get_list_kb_items', data: data }).then(obj => {
                this.kbRelatedItemsAvailable = obj.kb_items
            }).catch(err => {
                console.log(err);
            })
        },
        addRelatedKbItem(index) {
            this.kbItem.kb_related_items.push({
                related_item_id: this.kbRelatedItemsAvailable[index].kb_item_id,
                topic: this.kbRelatedItemsAvailable[index].topic
            })
            this.kbRelatedItemsAvailable.splice(index, 1)
        },
        removeRelatedKbItem(index) {
            this.$set(this.kbItem.kb_related_items[index], 'delete', 1)
        },
        saveArticle() {
            this.saving = true
            this.apiCall({ destination: 'save_item_kb_item', data: this.kbItem }).then(obj => {
                this.saving = false
                if (this.kb_item_id == 'new') {
                    this.fetchKBMenu()
                    this.$router.push('/admin/articles/' + obj.kb_item_id)
                } else {
                    this.fetchData()
                    this.fetchKBMenu()
                    this.kbRelatedItemsSearchTerm = null
                }
            }).catch(err => {
                this.saving = false
                console.log(err);
            })
        },
        theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
        tagNotInTagsList(filteredTag) {
            var tags = this.kbItem.kb_tags.filter(tag => {
                return tag.description == filteredTag
            })
            return tags.length == 0
        },
        moveSelectedTag(event) {
            if (event.keyCode == 40) {
                this.selectedTagIndex = (this.selectedTagIndex == this.filteredTags.length - 1) ? 0 : this.selectedTagIndex + 1
            }
            if (event.keyCode == 38) {
                this.selectedTagIndex = (this.selectedTagIndex == 0) ? this.filteredTags.length - 1 : this.selectedTagIndex - 1
            }
        },
        addTag() {
            if (!this.tagFilter) return
            if (!this.tagNotInTagsList(this.tagFilter)) return

            if (this.filteredTags.length == 0) {
                this.kbItem.kb_tags.push({
                    kb_tag_id: null,
                    description: this.tagFilter
                })
            } else {
                this.kbItem.kb_tags.push(this.filteredTags[this.selectedTagIndex])
            }
            this.tagFilter = null
            this.selectedTagIndex = 0
        },
        removeTag(index) {
            if (this.kbItem.kb_tags[index].kb_tag_id) {
                this.$set(this.kbItem.kb_tags[index], 'delete', 1)
            } else {
                this.kbItem.kb_tags.splice(index, 1)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.sorting-link { cursor: pointer; }
ul { margin-left: 1em; }
.modal .inner {
    min-width: 25em;
    min-height: 25em;

    .loading {
        margin-top: 6rem;
    }
}
</style>
